module.exports = __webpack_public_path__ + "static/img/znfd.9f834261.jpg";